import { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import Slider from "react-slick";
import sign from "../../../assets/images/sign.png";

const VideoSlider = () => {
  const Catalogues = [
    {
      id: "01",
      name: "https://www.youtube.com/watch?v=ysz5S6PUM-U",
    },
    {
      id: "02",
      name: "https://www.youtube.com/watch?v=ysz5S6PUM-U",
    },
    {
      id: "03",
      name: "https://www.youtube.com/watch?v=ysz5S6PUM-U",
    },
    {
      id: "04",
      name: "https://www.youtube.com/watch?v=ysz5S6PUM-U",
    },
    {
      id: "05",
      name: "https://www.youtube.com/watch?v=ysz5S6PUM-U",
    },
    {
      id: "06",
      name: "https://www.youtube.com/watch?v=ysz5S6PUM-U",
    },
    {
      id: "07",
      name: "https://www.youtube.com/watch?v=ysz5S6PUM-U",
    },
    {
      id: "08",
      name: "https://www.youtube.com/watch?v=ysz5S6PUM-U",
    },
  ];

  const [list, setList] = useState([]);
  const [isCheck, setIsCheck] = useState([]);

  useEffect(() => {
    setList(Catalogues);
  }, []);

  const handleClick = (e) => {
    const { id, checked } = e.target;
    setIsCheck([...isCheck, id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== id));
    }
  };

  var settings = {
    dots: true,
    infinite: true,
    // autoplay: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };



  const slideVideo = list.map(({ id, name }) => {
    return (
      <>
        <div key={id} className="col-md-2" id="id_work_days">
          <label className="card positionRel">
            <input key={id} id={id} name={name} type="checkbox" onChange={handleClick} checked={isCheck.includes(id)} />
            <span className=" core-category-btn category-core py-auto">
              <ReactPlayer width="100%" height="185px" url={name} />
            </span>
            <img className="img-fluid img-pixel" width="30px" src={sign} alt="" />
          </label>
        </div>
      </>
    );
  });

  return (
    <>

      <div className="row">

        {Catalogues.map((Catalogues) =>

          <div className="col-md-2">
            <div className="card m-2 my-3 card-bg">
              <ReactPlayer width="100%" height="185px" url={Catalogues.name} />
            </div>
          </div>
        )}
      </div>

      <div className="row">
        {slideVideo}
      </div>
    </>
  );
};

export default VideoSlider;